import { useState } from "react";
import { ChakraSimpleGrid as SimpleGrid } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { CardDesktop as Card } from "../Card";
import type { CardsDesktopProps } from "./Cards.d";

const CardsDesktop = ({
  cards,
  cardsHeightDesktop = "330px",
  sbEditable,
}: SbEditableComponentProps<CardsDesktopProps>) => {
  const [{ heading: firstCardHeader }] = (cards.length && cards) || [{ heading: "" }];
  const [openCard, setOpenCard] = useState(firstCardHeader);

  return (
    <SimpleGrid columns={cards.length % 2 ? { base: 1, lg: 3 } : { base: 2, lg: 2, xl: 4 }} spacing={8} {...sbEditable}>
      {cards.map(({ heading, text, icon, subHeading, _uid }) => (
        <Card
          icon={icon}
          key={_uid}
          heading={heading}
          text={text}
          setOpenCard={setOpenCard}
          openCard={openCard}
          cardsHeightDesktop={cardsHeightDesktop}
          subHeading={subHeading}
        />
      ))}
    </SimpleGrid>
  );
};

export default CardsDesktop;
